import { SternumTheme } from '@sternum/theme';
import { TooltipTheme } from '@sternum/ui';

import { Colors } from '../constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMDarkTooltipTheme(theme: SternumTheme): Partial<TooltipTheme> {
  return {
    tooltipBackgroundColor: Colors.Lighter,
    arrowBackgroundColor: Colors.Lighter,
    tooltipColor: Colors.DarkerText,
    tooltipBorderRadius: '4px',
    arrowHeight: '8px',
    arrowWidth: '8px',
    arrowBorderRadius: '2px',
    tooltipPadding: '4px 8px',
  };
}
